module.exports = __webpack_public_path__ + "img/level3addon_idle_mask.2167b243.png";